(function () {
  'use strict';

  function clampQty(input, next) {
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var max = parseInt(input.getAttribute('max') || '9999', 10);
    if (!isFinite(min) || min < 1) {
      min = 1;
    }
    if (!isFinite(max) || max < min) {
      max = 9999;
    }
    var n = parseInt(String(next), 10);
    if (!isFinite(n)) {
      n = min;
    }
    if (n < min) {
      n = min;
    }
    if (n > max) {
      n = max;
    }
    input.value = String(n);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function bindQty(root) {
    if (!root || root.getAttribute('data-cw-product-qty-ready') === '1') {
      return;
    }
    var input = root.querySelector('input.qty[name="quantity"]');
    if (!input) {
      return;
    }
    root.setAttribute('data-cw-product-qty-ready', '1');

    var minus = root.querySelector('[data-cw-product-qty-minus]');
    var plus = root.querySelector('[data-cw-product-qty-plus]');
    if (minus) {
      minus.addEventListener('click', function () {
        clampQty(input, parseInt(input.value || '1', 10) - 1);
      });
    }
    if (plus) {
      plus.addEventListener('click', function () {
        clampQty(input, parseInt(input.value || '1', 10) + 1);
      });
    }
    input.addEventListener('blur', function () {
      clampQty(input, input.value);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-cw-product-qty]').forEach(bindQty);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (typeof jQuery !== 'undefined') {
    jQuery(document.body).on('show_variation', 'form.variations_form', function () {
      window.setTimeout(initAll, 30);
    });
  }
})();
